/**
 * Test IDs for QA automation.
 */
export const testIds = {
  orderFormOrderNumber: "order-form-order-number",
  orderFormRemoveReceiver: "order-form-remove-receiver",
  orderFormAddReceiver: "order-form-add-receiver",
  orderFormSubmit: "order-form-submit",
} as const;
